module.exports = __webpack_public_path__ + "static/3-8f5b71e129fee272af536b9c404343a8.jpg";